import { Link } from "react-router";

export function NotFound() {
  return (
    <div style={{ textAlign: "center", padding: "64px 24px" }}>
      <p className="eyebrow" style={{ marginBottom: 12 }}>404</p>
      <h1 style={{ fontSize: 32, fontWeight: 700, letterSpacing: "-0.03em", margin: "0 0 16px" }}>Page not found.</h1>
      <p style={{ color: "rgb(var(--color-ink-muted))", margin: "0 0 24px" }}>The page you tried doesn't exist.</p>
      <Link to="/" className="btn btn-primary">Back home</Link>
    </div>
  );
}
